import { supabase } from '../lib/supabaseClient';

export const fetchProfile = async (userId) => {
  if (!userId) {
    throw new Error('User ID is required to fetch profile data.');
  }

  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();

  if (error && error.code !== 'PGRST116') {
    throw error;
  }

  return data ?? null;
};

export const updateProfile = async (userId, updates = {}) => {
  if (!userId) {
    throw new Error('User ID is required to update profile data.');
  }

  const payload = {
    ...updates,
    updated_at: new Date().toISOString(),
  };

  const { data, error } = await supabase
    .from('profiles')
    .update(payload)
    .eq('id', userId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  // If no row was updated (e.g., profile missing), fall back to fetching existing record
  if (!data) {
    return fetchProfile(userId);
  }

  return data;
};
